"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorMap = void 0;
exports.OperatorMap = {
    $gt: ">",
    $gte: ">=",
    $eq: "==",
    $ne: "!=",
    $lt: "<",
    $lte: "<=",
    $in: "in",
    $elemMatch: "array-contains",
    ">": ">",
    ">=": ">=",
    "==": "==",
    "<": "<",
    "<=": "<=",
    in: "in",
    "array-contains": "array-contains",
    "array-contains-any": "array-contains-any",
};
